import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowRejectionService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/workflowrejections`;

  constructor(private http: HttpClient) { }

  save(rejection: Boo.Objects.WorkflowRejection): Observable<any> {
    return this.http.post(`${this.baseUrl}/save`, rejection);
  }
}
